import React from "react";
import { addToAllDaysHandler } from "@ts/day-parting";
import DayPartingTimePicker from "./DayPartingTimePicker";
import { IDprCheckedData, TDprSlots } from "@ts/common-types";

interface IContainer {
    containerKey: number;
    onTimeCardHandler: (containerKey: number | any) => void;
    day: string;
    dprTimeSlots: TDprSlots;
    setDprTimeSlots: React.Dispatch<React.SetStateAction<TDprSlots>>;
    daypartingCardCheckedData: IDprCheckedData;
    setDaypartingCardCheckedData: React.Dispatch<
        React.SetStateAction<IDprCheckedData>
    >;
    canManageDayParting: boolean
}
const DayPartingTimePickerContainer: React.FC<IContainer> = ({
    containerKey,
    onTimeCardHandler,
    day,
    dprTimeSlots,
    setDprTimeSlots,
    daypartingCardCheckedData,
    setDaypartingCardCheckedData,
    canManageDayParting
}) => {
    return (
        <div>
            <div
                className={`${"card p-2 mb-2 " + day}-time-card`}
                id={`${day}-time-card-${containerKey}`}
                key={containerKey}
                style={{
                    backgroundColor: "rgba(0, 158, 255, 0.15)",
                    border: "none",
                }}
            >
                <div className="mt-2">
                    <DayPartingTimePicker {...{ day, containerKey, canManageDayParting }} />
                    <div className="d-flex justify-content-between mt-3 align-center">
                        <div className="d-flex">
                            <input
                                className="mx-2"
                                id={`${day}-all-days-${containerKey}`}
                                type="checkbox"
                                name="all-days"
                                disabled={true}
                                onChange={() => {
                                    addToAllDaysHandler({
                                        day,
                                        containerKey,
                                        dprTimeSlots,
                                        setDprTimeSlots,
                                        daypartingCardCheckedData,
                                        setDaypartingCardCheckedData,
                                    });
                                }}
                            />
                            <span>All Days</span>
                        </div>
                        <div>
                            <span
                                style={{
                                    cursor: `${canManageDayParting ? "pointer" : "default"}`,
                                    color: `${canManageDayParting ? "#FF1E00" : "#D3D3D3"}`,
                                }}
                                onClick={() => { canManageDayParting ? onTimeCardHandler(containerKey) : null }}
                            >
                                Remove
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DayPartingTimePickerContainer;
